export default "__VITE_ASSET__QEPPsSv0__"